let isListenerAdded = false; // Track if listeners are already added
const getInternetStatus = ({ setIsInternetConnected }) => {
    const onInternetStatusChange = () => {
        const currentStatus = navigator.onLine;
        setIsInternetConnected(currentStatus); // Update only if the status actually changes
    };
    // Prevent duplicate event listeners
    if (!isListenerAdded) {
        window.addEventListener("online", onInternetStatusChange);
        window.addEventListener("offline", onInternetStatusChange);
        isListenerAdded = true;
    }
    // Report initial status
    onInternetStatusChange();
};
export default getInternetStatus;
